import { CandidateImportRequestsNewTemplate } from '@/features/agent/candidate_import_requests/templates/CandidateImportRequestsNewTemplate';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/agent/candidates/candidate_import_requests/new/')({
  component: RouteComponent,
});

function RouteComponent() {
  return <CandidateImportRequestsNewTemplate />;
}
